// extracted by mini-css-extract-plugin
export default {"link":"_1795ef3","icon":"_10161898"};